import styled from 'styled-components';

const ShopContainer = styled.div`
  padding: 2rem;
  ${({ plain, theme }) =>
    plain
      ? ''
      : `
  background-color: ${theme.colors.background};
  color: ${theme.colors.text};
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  `}
`;

export default ShopContainer;